import React from "react";
import { ReactComponent as SVGlogo } from "../../assets/logo.svg";
import PropTypes from "prop-types";

const MaintenanceIndicator = ({ errorMessage, hasLogo = true }) => {
  return (
    <div className="MaintenanceIndicator">
      <h1 className="MaintenanceIndicator__title">Under Maintenance</h1>
      {hasLogo && <SVGlogo className="MaintenanceIndicator__logo" />}
      <div className="MaintenanceIndicator__text">
        {Array.isArray(errorMessage) ? (
          errorMessage.map((message, index) => (
            <p key={`${index}:${message}`}>{message}</p>
          ))
        ) : (
          <p>{errorMessage}</p>
        )}
      </div>
    </div>
  );
};

MaintenanceIndicator.propTypes = {
  errorMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
  hasLogo: PropTypes.bool,
};

export default MaintenanceIndicator;
